import { createContext } from 'react'

// Load the room once and use it down the Notifications tree
export const NotificationRoomContext = createContext({
  room: null,
  isReady: false,
})
